/**
 * Sends client-side errors to the backend for CloudWatch logging.
 * Uses sendBeacon for reliability (fires even during page unload).
 */
export function reportError(
  message: string,
  context?: Record<string, unknown>,
  error?: unknown
): void {
  try {
    const payload = {
      message,
      stack: error instanceof Error ? error.stack : undefined,
      context: {
        ...context,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      },
    };

    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    const sent = navigator.sendBeacon('/api/v1/gmail-extractor/report-error', blob);

    if (!sent) {
      // Fallback to fetch if sendBeacon fails (e.g., payload too large)
      fetch('/api/v1/gmail-extractor/report-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).catch(() => {
        /* best-effort */
      });
    }
  } catch {
    // Never let error reporting break the app
  }
}
